// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1v-iP","selected":"Chip_selected__37GM3"};